import React, { useEffect } from 'react';
import Module from '../../../layout/Module';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import List from './Generator/List/List';
import { useDispatch, useSelector } from 'react-redux';
import DialogAction from './Generator/Dialog/Dialog';
import NotFoundPage from '../../../NotFoundPage/NotFoundPage';
import AlertSaveButton from '../../../button/AlertSaveButton';
import { toggleDialog } from '../../../../store/actions/periodical-report.actions';
import PeriodicalReportSetting from './Setting/Setting';
import PeriodicalReportMarking from './Marking/Marking';
import EditPreview from './Generator/EditPreview/EditPreview';
import useYears from '../../../../hooks/setting/useYears';

const PeriodicalReportContainer = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const permissions = useSelector(
    (state) => state?.session?.permissions?.['periodical-report-generator'] || {}
  );
  const permissionsSetting = useSelector(
    (state) => state?.session?.permissions?.['periodical-report-setting'] || 
    state?.session?.permissions?.['periodical-report-period'] || 
    state?.session?.permissions?.['periodical-report-type'] || {}
  );
  const openDialog = useSelector((state) => state?.periodicalReport?.dialog.open || false);
  const dialog = useSelector((state) => state?.periodicalReport?.dialog || {});
  const { getYears } = useYears()

  const dispatch = useDispatch();

  const onRedirect = (redirectTo) => {
    navigate(`/dashboard/periodical-report${redirectTo}`);
  };

  useEffect(() => {
    getYears()
  }, [])

  return (
    <Module moduleName='periodical-report'>
      <Module.Header
        title='Periodical Report'
        titleLink={'/dashboard/periodical-report'}
      >
        {pathname.indexOf('/dashboard/periodical-report/marking') === -1 && (
        <div className='flex gap-2'>
        {permissionsSetting.updated && (
          <>
          <AlertSaveButton
            submodule='Periodical Report'
            icon='cogs'
            title='Setting'
            color='secondary'
            onDontSave={() => {
              onRedirect('/setting')
            }}
          />
          <div className='px-4' />
          </>
        )}
        { permissions?.created && (
          <AlertSaveButton
            submodule='Periodical Report'
            icon='th-list'
            title='List'
            color='secondary'
            onDontSave={() => {
              onRedirect('')
            }}
          />
        )}
        { permissions?.created && (
          <AlertSaveButton
            submodule='Periodical Report'
            icon='plus'
            title='Create'
            color='secondary'
            onDontSave={() => dispatch(toggleDialog('create'))}
          />
        )}
        </div>
        )}

      </Module.Header>
      <Module.Body>
        <Routes>
          <Route index element={<List />} />
          <Route path='edit/:periodicalReportId/*' Component={EditPreview} />
          <Route path='preview/:periodicalReportId/*'  Component={EditPreview}  />
          <Route path='marking/:periodicalReportId/*' element={<PeriodicalReportMarking />} />
          <Route path='setting/*' Component={PeriodicalReportSetting} />
          <Route
            path='*'
            element={
              <Module.BodyFullContainer className='flex justify-center items-center'>
                <NotFoundPage />
              </Module.BodyFullContainer>
            }
          />
        </Routes>
      </Module.Body>
      {openDialog && (
        <DialogAction
          show={openDialog}
          type={dialog.type}
          formData={dialog.form}
          onClose={() => dispatch(toggleDialog())}
        />
      )}
    </Module>
  );
};

export default PeriodicalReportContainer;
